import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';
const TOTAL_SECONDS = 17 * 60 + 34;
const pad = (n: number) => String(n).padStart(2, '0');
export function Countdown({
  tone = 'light'
}: {
  tone?: 'light' | 'dark';
}) {
  const [remaining, setRemaining] = useState(TOTAL_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? TOTAL_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor(remaining % 3600 / 60);
  const seconds = remaining % 60;
  const units = [{
    value: pad(hours),
    label: 'ORE'
  }, {
    value: pad(minutes),
    label: 'MIN'
  }, {
    value: pad(seconds),
    label: 'SEC'
  }];
  const dark = tone === 'dark';
  return <div className="w-full" data-id="element-82" data-mp="10degjf978lpy">
      <p className={`mb-2 text-center text-[11px] font-extrabold uppercase tracking-[0.18em] sm:text-xs ${dark ? 'text-white/80' : 'text-inksoft'}`} data-id="element-83" data-mp="10d4uu3v6t0q2">
        <ClockIcon className="mr-1 inline h-3.5 w-3.5 align-[-2px]" aria-hidden="true" data-id="element-84" data-mp="xzlrjnrhqsuf" />
        L’offerta scade tra
      </p>
      <div className="mx-auto flex max-w-xs items-stretch justify-center gap-2" role="timer" aria-live="off" data-id="element-85" data-mp="t093x0ssphqs">
        {units.map(u => <div key={u.label} className={`flex flex-1 flex-col items-center rounded-xl border px-2 py-2 ${dark ? 'border-white/20 bg-white/10 text-white' : 'border-brand-100 bg-white text-ink'}`} data-id="element-86" data-mp="12seuq77b9t4e">
            <span className="font-display text-2xl font-bold leading-none tabular-nums sm:text-3xl" data-id="element-87" data-mp="o3s8rmn6i347">
              {u.value}
            </span>
            <span className={`mt-1 text-[10px] font-bold uppercase tracking-widest ${dark ? 'text-white/70' : 'text-inksoft'}`} data-id="element-88" data-mp="1zi5no1zyf883">
              {u.label}
            </span>
          </div>)}
      </div>
    </div>;
}